import React from "react";
import { useNavigate } from 'react-router-dom';
import { Toast } from '../../utils/ToastNotification';

const Login = () => {
    const navigate = useNavigate();

    const handleLogin = () => {
        Toast(true, 'Login Successfully!');
        localStorage.setItem('token', 'f4crt48rv73t4gr7gt3478rctv7vr')
        navigate("/");
    }

    return (
        <>
            <div className="card-body">
                <a href="javascript:void(0);" className="text-nowrap logo-img text-center d-block py-3 w-100">
                <img src="/Logo-black.png" width="70%" alt="ADOT" />
                </a>
                {/* <p className="text-center">Your Social Campaigns</p> */}
                <form>
                    <div className="mb-3">
                        <label for="exampleInputEmail1" className="form-label">Username</label>
                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                    </div>
                    <div className="mb-4">
                        <label for="exampleInputPassword1" className="form-label">Password</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="form-check">
                            <input className="form-check-input primary" type="checkbox" value="" id="flexCheckChecked" checked />
                            <label className="form-check-label text-dark" for="flexCheckChecked">
                                Remeber this Device
                            </label>
                        </div>
                        <a className="text-primary fw-bold" href="./index.html">Forgot Password ?</a>
                    </div>
                    <a onClick={handleLogin} className="btn btn-primary w-100 py-8 fs-4 mb-4 rounded-2">Sign In</a>
                    <div className="d-flex align-items-center justify-content-center">
                        <p className="fs-4 mb-0 fw-bold">New to ADOT?</p>
                        <a className="text-primary fw-bold ms-2" href="javascript:void(0);">Create an account</a>
                    </div>
                </form>
            </div>
        </>
    )
}
export default Login;